class StoreLocator {
  // Constructor initializes the configuration and stores data
  constructor(config) {
    // Default config values are provided, allowing for overrides through the passed config
    this.config = {
      containerSelector: '.currentlocation', // Selector for the element where the selected store name will appear
      locationMessageSelector: '.modal-location-message', // Selector for the element showing location messages
      checkboxSelector: '.location-checkbox', // Selector for the store location checkboxes
      popupSelector: '.open-popup-link', // Selector for the popup link to open the store locations
      optionTitleSelector: '.option-title', // Selector for the option title in the store list
      ...config // Merge default config with the passed config
    };

    // Ensure storeData is correctly parsed as an array (either provided as an array or JSON string)
    this.storeData = Array.isArray(config.storeData) ? config.storeData : JSON.parse(config.storeData || '[]');
    this.init(); // Initialize the locator
  }

  // Method to initialize the StoreLocator functionality
  init() {
    this.initializeMagnificPopup(); // Initialize popup functionality
    this.initializeDropdowns(); // Initialize dropdowns for store options
    this.initializeCheckboxes(); // Initialize checkboxes functionality
    this.getCurrentLocation(); // Try to get the user's current location
    this.updateLocationDisplay(); // Update the display with the stored location data
    
  }

// Function to handle the AJAX request to get store location by Zip code
getStoreByZipCode(zipCode) {
  // Use an API to get latitude and longitude from the zip code (e.g., Google Geocoding API)
  $.ajax({
    url: `https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=AIzaSyDnItSYzNeAQB1XXfZljBOcH9xZDjqWERY`,  // Example API, replace with your preferred geocoding service
    method: 'GET',
    success: (data) => {
      const lat = data.results[0].geometry.location.lat;
      const lng = data.results[0].geometry.location.lng;

      // Find the closest store
      const closestStore = this.findClosestStore(lat, lng, true);
      
      // Update the UI with only the closest store
      if (closestStore) {
        this.filterCheckboxes(closestStore.name);
        this.updateLocationDisplay(); // Update location display to show the closest store
      } else {
        alert('No stores found nearby.');
      }
    },
    error: (error) => {
      console.error('Error fetching geolocation data:', error);
      alert('Failed to find location. Please try again.');
    }
  });
}



// Function to filter and show only the closest store in the options list
filterCheckboxes(closestStoreName) {
  const options = document.querySelectorAll("#options .option");

  options.forEach(option => {
    const checkbox = option.querySelector(".location-checkbox");
    const storeName = checkbox.getAttribute("data-name");

    if (storeName === closestStoreName) {
      option.style.display = "block"; // Show the closest store
      checkbox.checked = true; // Check the closest store's checkbox
    } else {
      option.style.display = "none"; // Hide other options
      checkbox.checked = false; // Uncheck other checkboxes
    }
  });
}



  

  // Method to initialize the Magnific Popup library for showing popups
  initializeMagnificPopup() {
    $(this.config.popupSelector).magnificPopup({
      type: 'inline',
      midClick: true, // Allow popup opening by middle-clicking
      mainClass: 'mfp-fade', // Add fade effect to the popup
    });
  }

  // Method to initialize dropdowns for each store option
  initializeDropdowns() {
    // Get all store option titles (to allow showing/hiding the address dropdown)
    const options = document.querySelectorAll(this.config.optionTitleSelector);
    options.forEach(option => {
      option.onclick = () => {
        const dropdown = option.nextElementSibling; // Get the associated dropdown for the current option
        // Close all other dropdowns
        document.querySelectorAll('.dropdown.active').forEach(activeDropdown => {
          if (activeDropdown !== dropdown) {
            activeDropdown.classList.remove('active');
            activeDropdown.style.display = 'none';
          }
        });

        // Toggle the current dropdown visibility
        if (dropdown.classList.contains('active')) {
          dropdown.classList.remove('active');
          dropdown.style.display = 'none';
        } else {
          dropdown.classList.add('active');
          dropdown.style.display = 'block';
        }
      };
    });
  }

  // Method to update location displays for all instances of the store locator
  updateAllInstances() {
    // Define the selectors for different store locator instances (mobile and desktop)
    const allSelectors = [
      {
        container: '.currentlocation',
        checkboxes: '.location-checkbox',
        locationMessage: '.modal-location-message'
      },
      {
        container: '.currentlocation-mob',
        checkboxes: '.location-checkbox-mob',
        locationMessage: '.modal-location-message-mob'
      }
    ];

    // Retrieve the selected locations and nearest location from localStorage
    const selectedLocations = JSON.parse(localStorage.getItem('selectedLocations') || '[]');
    const nearestLocation = JSON.parse(localStorage.getItem('nearestLocation') || 'null');

    // Loop through all store locator instances and update the display
    allSelectors.forEach(({ container, checkboxes, locationMessage }) => {
      const displayElement = document.querySelector(container);
      const locationMessageElement = document.querySelector(locationMessage);

      if (displayElement) {
        // Set the text of the current location display element
        displayElement.textContent = selectedLocations.length > 0 ? selectedLocations[0] : 'Store Locations';
      }

      // Loop through the checkboxes and set the checked state based on selected locations
      const checkboxElements = document.querySelectorAll(checkboxes);
      checkboxElements.forEach(checkbox => {
        checkbox.checked = selectedLocations.includes(checkbox.getAttribute('data-name'));
      });

      // Display a message if no location is selected
      if (locationMessageElement && selectedLocations.length === 0) {
        locationMessageElement.style.display = 'block';
        locationMessageElement.textContent = 'Please select a location.';
      }

      // Display the nearest location message, if applicable
      if (nearestLocation) {
        const nearestCheckbox = document.querySelector(`${checkboxes}[data-name="${nearestLocation}"]`);
        if (nearestCheckbox) {
          const nearestMessage = document.createElement('span');
          nearestMessage.className = 'nearest-location-message';
          nearestMessage.textContent = 'This is the nearest location';
          // Only append the message if it doesn't already exist
          if (!nearestCheckbox.parentElement.querySelector('.nearest-location-message')) {
            nearestCheckbox.parentElement.appendChild(nearestMessage);
          }
        }
      }
    });
  }

  // Method to initialize checkbox event handlers
  initializeCheckboxes() {
    const checkboxes = document.querySelectorAll(this.config.checkboxSelector);
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        // Uncheck all other checkboxes when one is selected
        checkboxes.forEach(cb => {
          if (cb !== checkbox) cb.checked = false;
        });

        // If a checkbox is checked, store the selected store in localStorage
        if (checkbox.checked) {
          const selectedStore = checkbox.getAttribute('data-name');
          localStorage.setItem('selectedLocations', JSON.stringify([selectedStore]));
        }

        // Update the display for all store locator instances
        this.updateAllInstances();
        UpdateProductPickups();
      });
    });
  }

  // Method to get the user's current location using geolocation API
getCurrentLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      position => {
        // If geolocation is successful, find the nearest store
        const selectedLocations = JSON.parse(localStorage.getItem('selectedLocations') || '[]');
        if (selectedLocations.length === 0) {
          this.findClosestStore(position.coords.latitude, position.coords.longitude);
        } else {
          this.findClosestStore(position.coords.latitude, position.coords.longitude);
          this.updateAllInstances();
        }
      },
      () => {
        const selectedLocations = JSON.parse(localStorage.getItem('selectedLocations') || '[]');
          if (selectedLocations.length === 0) {
                  this.selectFirstLocation();
        } else {
          this.updateAllInstances();
        }
        console.warn('Geolocation failed');
        localStorage.removeItem('nearestLocation'); // Clear nearest location
        // If geolocation fails, select the first checkbox as default
      }
    );
  } else {
    // If geolocation is not supported, select the first checkbox as default
    console.warn('Geolocation is not supported');
    localStorage.removeItem('nearestLocation'); // Clear nearest location
    this.selectFirstLocation();
  }
}


  // Method to find the closest store based on the user's coordinates
  findClosestStore(userLat, userLng , sestionUpdate) {
    let closestStore = null;
    let minDistance = Infinity;

    // Loop through all the stores and calculate the distance to the user's location
    this.storeData.forEach(store => {
      const distance = this.calculateDistance(userLat, userLng, store.lat, store.lng);
      if (distance < minDistance) {
        minDistance = distance;
        closestStore = store;
      }
    });

    if(sestionUpdate)
    {
     return closestStore;
      
    }
    // Store the closest store and update the display
    if (closestStore) {
       const selectedLocations = JSON.parse(localStorage.getItem('selectedLocations') || '[]');
        if (selectedLocations.length === 0) { 
      localStorage.setItem('selectedLocations', JSON.stringify([closestStore.name]));
        }
      localStorage.setItem('nearestLocation', JSON.stringify(closestStore.name));  // Store the nearest location
      this.updateAllInstances();
    }
  }

  // Utility method to calculate distance between two points using the Haversine formula
  calculateDistance(lat1, lng1, lat2, lng2) {
    const R = 6371; // Radius of the Earth in km
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLng = ((lng2 - lng1) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);

    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); // Return the distance in kilometers
  }

  // Method to update the location display based on selected store and nearest location
  updateLocationDisplay() {
    const selectedLocations = JSON.parse(localStorage.getItem('selectedLocations') || '[]');
    const displayElement = document.querySelector(this.config.containerSelector);
    displayElement.textContent = selectedLocations.length > 0 ? selectedLocations[0] : 'Store Locations';

    const checkboxes = document.querySelectorAll(this.config.checkboxSelector);
    checkboxes.forEach(checkbox => {
      checkbox.checked = selectedLocations.includes(checkbox.getAttribute('data-name'));
    });

    // Remove any existing nearest location messages
    document.querySelectorAll('.nearest-location-message').forEach(msg => msg.remove());
    const nearestLocation = JSON.parse(localStorage.getItem('nearestLocation'));

    if (nearestLocation) {
      const nearestCheckbox = document.querySelector(`${this.config.checkboxSelector}[data-name="${nearestLocation}"]`);
      if (nearestCheckbox) {
        const messageElement = document.createElement('span');
        messageElement.className = 'nearest-location-message';
        messageElement.textContent = 'This is the nearest location';
        // Only append the message if it doesn't already exist
        if (!nearestCheckbox.parentElement.querySelector('.nearest-location-message')) {
          nearestCheckbox.parentElement.appendChild(messageElement);
        }
      }
    }
    
    return displayElement.textContent
  }
  selectFirstLocation() {
  const checkboxes = document.querySelectorAll(this.config.checkboxSelector);
  if (checkboxes.length > 0) {
    // Select the first checkbox
    const firstCheckbox = checkboxes[0];
    firstCheckbox.checked = true;

    // Save the first location to localStorage
    // const firstLocationName = firstCheckbox.getAttribute('data-name');
    // localStorage.setItem('selectedLocations', JSON.stringify([firstLocationName]));

    // Update the location display
    // this.updateAllInstances();
      checkboxes.forEach((checkbox, index) => {
    if (index === 0) {
      checkbox.checked = true; // Only check the first checkbox
      const selectedStore = checkbox.getAttribute('data-name'); // Get the name of the selected checkbox
      document.querySelector('.currentlocation').textContent = selectedStore; // Update .currentlocation with the name
      document.querySelector('.currentlocation-mob').textContent = selectedStore; // Update .currentlocation with the name
    } else {
      checkbox.checked = false; // Uncheck the others
    }
  });
  }
}  
}
